import { Appointment } from "@/modules/schedule/type";
import { Badge, Divider, Group, Text } from "@mantine/core";
import moment from "moment-jalaali";

type Props = {
  appointment: Appointment;
  isToday: boolean;
  selectedDate: Date;
};

function AppointmentBadge({ appointment, isToday, selectedDate }: Props) {
  const timeNow = moment().format("HH:mm");
  const appointmentTime = moment(appointment.time, "HH:mm");
  const nowTime = moment(timeNow, "HH:mm");

  return (
    <Badge
      size="xs"
      color={
        isToday && appointmentTime.isSameOrAfter(nowTime)
          ? appointment?.color
          : isToday && appointmentTime.isSameOrBefore(nowTime)
          ? "gray.4"
          : !isToday && moment().isBefore(selectedDate)
          ? appointment?.color
          : "gray.4"
      } // Use moment comparison
      fullWidth
      py="xs"
      key={appointment?.id}
      styles={{
        root: {
          position: "relative",
        },
        section: {
          position: "absolute",
          right: 5,
          top: 3,
        },
      }}
      rightSection={
        <Group gap="5" p="0">
          <Text size="xs" truncate="end">
            {appointment?.time}
          </Text>
          <Divider orientation="vertical" mb={3} />
        </Group>
      }
    >
      <Text size="xs" truncate="end">
        {appointment?.customerName}
      </Text>
    </Badge>
  );
}

export default AppointmentBadge;
